module.exports = __webpack_public_path__ + "static/icons/icon-search-9be925a2f3cf16061475f39f14b2db68.svg";